import React from 'react';
import './CirclesBackground.css';

export const CirclesBackground = () => {
  return (
    <div className="circlesBackground">
      <div className="circlesBackground__bigC"></div>
      <div className="circlesBackground__midC"></div>
      <div className="circlesBackground__smallC"></div>
    </div>
  );
};
